import React from 'react';
import { graphql } from 'gatsby';
import Layout from '../components/Layout';
import { HTMLContent } from '../components/Content';
import { ContactForm } from '../views/contact-form';
import PreviewCompatibleImage from '../components/PreviewCompatibleImage';
import { openLightbox } from '../actions/lightbox';
import { Contacts } from '../components/contacts';

const SPLITTER = '<p>*ТУТ ГАЛЕРЕЯ КАК В ПОРТФОЛИО*</p>';

export default ({ data, location }) => {
  const { markdownRemark, images: imgs } = data;

  const title = markdownRemark.frontmatter.title;
  const content = markdownRemark.html;
  const images = imgs.edges.map(({ node }) => node);

  const [contentBeforeSplit, contentAfterSplit] = content.split(SPLITTER);

  return (
    <Layout location={location} title={title}>
      <section className="section">
        <div className="container">
          <h1 className="title is-1 has-text-centered">{title}</h1>
          <HTMLContent className="content" content={contentBeforeSplit} />
          {!!(images && images.length) && (
            <div className="columns is-multiline">
              {images.map((image, index) => (
                <div
                  className="column is-one-quarter"
                  key={image.id}
                  onClick={() =>
                    openLightbox(location, {
                      fluids: images.map((image) => image.originalFluid),
                      index,
                    })
                  }
                >
                  {image.previewFluid && <PreviewCompatibleImage fluid={image.previewFluid} />}
                </div>
              ))}
            </div>
          )}
          <HTMLContent className="content" content={contentAfterSplit} />
          <h4 className="title is-4">
            Чтобы узнать, свободна ли нужная дата и какая стоимость оформления, напиши мне любым
            способом или оставь заявку и я сама свяжусь с тобой :)
          </h4>
          <hr />
          <div className="columns">
            <div className="column">
              <Contacts />
            </div>
            <div className="column">
              <ContactForm />
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export const decorPageQuery = graphql`
  query DecorPage($id: String!) {
    images: allImageSharp(filter: { fluid: { originalName: { regex: "/decor-(.*).jpg/" } } }) {
      edges {
        node {
          id
          previewFluid: fluid(maxWidth: 800, maxHeight: 600, quality: 65) {
            ...GatsbyImageSharpFluid_withWebp
          }
          originalFluid: fluid(maxWidth: 500) {
            originalImg
            src
          }
        }
      }
    }

    markdownRemark(id: { eq: $id }) {
      html
      frontmatter {
        title
      }
    }
  }
`;
